import { useLanguage } from "@/i18n/LanguageContext";

const LANGS = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

export const LanguageSwitcher = ({ compact = false }) => {
  const { language, setLanguage, t } = useLanguage();
  return (
    <div
      data-testid="language-switcher"
      role="group"
      aria-label={t("switcher.aria")}
      className={`flex items-center border border-ink/10 ${
        compact ? "rounded-sm" : ""
      }`}
    >
      {LANGS.map((l) => {
        const active = language === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLanguage(l.code)}
            data-testid={`lang-${l.code}`}
            aria-pressed={active}
            className={`${
              compact ? "px-2 py-1 text-[11px]" : "px-2.5 py-1.5 text-[11px]"
            } tracking-[0.18em] uppercase transition-colors duration-300 ${
              active
                ? "bg-gold-strong text-on-gold"
                : "text-ink-muted hover:text-gold-ink"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
